module.exports = __webpack_public_path__ + "static/media/openflow.2b58515b.png";